import axiosInstance from './axios';
import {
	DASHBOARD_OVERVIEW,
	DASHBOARD_OFFICER_STATS,
	DASHBOARD_BRANCH_STATS,
	DASHBOARD_CASE_RESOLUTION_TIME,
	DASHBOARD_CASE_DISTRIBUTION_BY_SUBCATEGORY,
	DASHBOARD_CASE_VOLUME_BY_BRANCH,
	DASHBOARD_PRIORITY_DISTRIBUTION,
	DASHBOARD_TOP_CATEGORIES,
	DASHBOARD_TOP_SUBCATEGORIES,
	DASHBOARD_TOP_CATEGORIES_COUNTRY_LEVEL,
	DASHBOARD_TOP_SUBCATEGORIES_COUNTRY_LEVEL,
	DASHBOARD_CASE_STATUS_SUMMARY,
	DASHBOARD_CASES_BY_BRANCH_STATUS,
	DASHBOARD_CASE_TRENDS_OVER_TIME,
	DASHBOARD_CASE_CREATION_TRENDS,
	DASHBOARD_ASSIGNMENT_STATUS_DISTRIBUTION,
	DASHBOARD_ASSIGNMENT_ACCEPTANCE_RATE,
	DASHBOARD_ORGANIZATION_PERFORMANCE,
	DASHBOARD_CASES_BY_REPORTING_TYPE,
	DASHBOARD_CASES_BY_DEMOGRAPHIC,
	DASHBOARD_MOST_REPORTED_DISTRICTS,
	DASHBOARD_TRANSFER_PERCENTAGE_BY_ORGANIZATION,
	DASHBOARD_CASES_SOURCE_DISTRIBUTION,
	DASHBOARD_ANONYMOUS_REPORT_RESOLUTION_RATE,
	DASHBOARD_OFFICER_COUNT_BY_DESIGNATION,
	DASHBOARD_SUBMITTED_CASES,
	DASHBOARD_CASE_DISTRIBUTION_BY_ORGANIZATION,
	DASHBOARD_ORGANIZATION_PERFORMANCE_HEATMAP,
	DASHBOARD_CASE_CLOSURE_RATE_BY_ORGANIZATION,
	DASHBOARD_CASE_TIMELINE_STATISTICS,
	DASHBOARD_OFFICER_PERFORMANCE,
	DASHBOARD_CASE_ASSIGNMENT_STATUS_SUMMARY,
} from '../apiRoutes';

// Generic GET helper for dashboard endpoints
const get = (url, params = {}) => axiosInstance.get(url, { params });

export const getDashboardOverview = (params) => get(DASHBOARD_OVERVIEW, params);
export const getDashboardOfficerStats = (params) => get(DASHBOARD_OFFICER_STATS, params);
export const getDashboardBranchStats = (params) => get(DASHBOARD_BRANCH_STATS, params);
export const getDashboardCaseResolutionTime = (params) => get(DASHBOARD_CASE_RESOLUTION_TIME, params);
export const getDashboardCaseDistributionBySubcategory = (params) => get(DASHBOARD_CASE_DISTRIBUTION_BY_SUBCATEGORY, params);
export const getDashboardCaseVolumeByBranch = (params) => get(DASHBOARD_CASE_VOLUME_BY_BRANCH, params);
export const getDashboardPriorityDistribution = (params) => get(DASHBOARD_PRIORITY_DISTRIBUTION, params);
export const getDashboardTopCategories = (params) => get(DASHBOARD_TOP_CATEGORIES, params);
export const getDashboardTopSubcategories = (params) => get(DASHBOARD_TOP_SUBCATEGORIES, params);
export const getDashboardTopCategoriesCountryLevel = (params) => get(DASHBOARD_TOP_CATEGORIES_COUNTRY_LEVEL, params);
export const getDashboardTopSubcategoriesCountryLevel = (params) => get(DASHBOARD_TOP_SUBCATEGORIES_COUNTRY_LEVEL, params);
export const getDashboardCaseStatusSummary = (params) => get(DASHBOARD_CASE_STATUS_SUMMARY, params);
export const getDashboardCasesByBranchStatus = (params) => get(DASHBOARD_CASES_BY_BRANCH_STATUS, params);
export const getDashboardCaseTrendsOverTime = (params) => get(DASHBOARD_CASE_TRENDS_OVER_TIME, params);
export const getDashboardCaseCreationTrends = (params) => get(DASHBOARD_CASE_CREATION_TRENDS, params);
export const getDashboardAssignmentStatusDistribution = (params) => get(DASHBOARD_ASSIGNMENT_STATUS_DISTRIBUTION, params);
export const getDashboardAssignmentAcceptanceRate = (params) => get(DASHBOARD_ASSIGNMENT_ACCEPTANCE_RATE, params);
export const getDashboardOrganizationPerformance = (params) => get(DASHBOARD_ORGANIZATION_PERFORMANCE, params);

export const getDashboardCasesByReportingType = (params) => get(DASHBOARD_CASES_BY_REPORTING_TYPE, params);
export const getDashboardCasesByDemographic = (params) => get(DASHBOARD_CASES_BY_DEMOGRAPHIC, params);
export const getDashboardMostReportedDistricts = (params) => get(DASHBOARD_MOST_REPORTED_DISTRICTS, params);
export const getDashboardTransferPercentageByOrganization = (params) => get(DASHBOARD_TRANSFER_PERCENTAGE_BY_ORGANIZATION, params);
export const getDashboardCasesSourceDistribution = (params) => get(DASHBOARD_CASES_SOURCE_DISTRIBUTION, params);
export const getDashboardAnonymousReportResolutionRate = (params) => get(DASHBOARD_ANONYMOUS_REPORT_RESOLUTION_RATE, params);
export const getDashboardOfficerCountByDesignation = (params) => get(DASHBOARD_OFFICER_COUNT_BY_DESIGNATION, params);
export const getDashboardSubmittedCases = (params) => get(DASHBOARD_SUBMITTED_CASES, params);
export const getDashboardCaseDistributionByOrganization = (params) => get(DASHBOARD_CASE_DISTRIBUTION_BY_ORGANIZATION, params);
export const getOrganizationPerformanceHeatmap = (params) => get(DASHBOARD_ORGANIZATION_PERFORMANCE_HEATMAP, params);
export const getCaseClosureRateByOrganization = (params) => get(DASHBOARD_CASE_CLOSURE_RATE_BY_ORGANIZATION, params);
export const getCaseTimelineStatistics = (params) => get(DASHBOARD_CASE_TIMELINE_STATISTICS, params);
export const getOfficerPreformance = (params) => get(DASHBOARD_OFFICER_PERFORMANCE, params);
export const getDashboardCaseAssignmentStatusSummary = (params) => get(DASHBOARD_CASE_ASSIGNMENT_STATUS_SUMMARY, params);

const DashboardServices = {
	getDashboardOverview,
	getDashboardOfficerStats,
	getDashboardBranchStats,
	getDashboardCaseResolutionTime,
	getDashboardCaseDistributionBySubcategory,
	getDashboardCaseVolumeByBranch,
	getDashboardPriorityDistribution,
	getDashboardTopCategories,
	getDashboardTopSubcategories,
	getDashboardTopCategoriesCountryLevel,
	getDashboardTopSubcategoriesCountryLevel,
	getDashboardCaseStatusSummary,
	getDashboardCasesByBranchStatus,
	getDashboardCaseTrendsOverTime,
	getDashboardCaseCreationTrends,
	getDashboardAssignmentStatusDistribution,
	getDashboardAssignmentAcceptanceRate,
	getDashboardOrganizationPerformance,
	getDashboardCasesByReportingType,
	getDashboardCasesByDemographic,
	getDashboardMostReportedDistricts,
	getDashboardTransferPercentageByOrganization,
	getDashboardCasesSourceDistribution,
	getDashboardAnonymousReportResolutionRate,
	getDashboardOfficerCountByDesignation,
	getDashboardSubmittedCases,
	getDashboardCaseDistributionByOrganization,
	getOrganizationPerformanceHeatmap,
	getCaseClosureRateByOrganization,
	getCaseTimelineStatistics,
	getOfficerPreformance,
	getDashboardCaseAssignmentStatusSummary,
};

export default DashboardServices;
